import './StellarSeasons.scss'

import { useEffect, useState } from "react"
import { useModal } from "../../../contexts/Modal"
import { useCharacters } from "../../../contexts/Characters"
import { useToaster } from "../../../contexts/Toaster"
import { useData } from "../../../contexts/Data"
import NewStellarSeason from "../../modals/NewStellarSeason/NewStellarSeason"
import koalition from "../../../api/koalition"
import useConfirmation from "../../../hooks/ConfimationHook"
import WriteKvk from '../../modals/WriteKvk/WriteKvk'

const StellarSeasons = ({}) => {
    const data = useData()
    const modal = useModal()
    const characters = useCharacters()
    const toaster = useToaster()
    const { isMarked, markOrExecute } = useConfirmation()

    const onNewStellarSeasonClick = () => {
        modal.open({ title: 'New Stellar Season', component: <NewStellarSeason /> })
    }

    const onStellarSeasonClick = (seasonId) => {
        koalition.put(`/stellarSeasons/${seasonId}`, { current: true }).then((response) => {
            toaster.success('Current season successfully set')
        }).catch((error) => {
            toaster.error(error)
            console.error(error)
        })
    }

    const onStellarSeasonDeleteClick = (event, seasonId) => {
        event.stopPropagation()
        markOrExecute(seasonId, () => deleteStellarSeason(seasonId))
    }

    const deleteStellarSeason = (seasonId) => {
        koalition.delete(`/stellarSeasons/${seasonId}`).then((response) => {
            toaster.success('Stellar season deleted successfully')
            modal.close()
        }).catch((error) => {
            toaster.error(error)
            console.error(error)
        })
    }

    const onNewKvkClick = (stellarSeason) => {
        modal.open({ title: 'Create Kvk', component: <WriteKvk />, data: { stellarSeason } })
    }

    const onKvkEditClick = (stellarSeason, kvk) => {
        modal.open({ title: 'Edit Kvk', component: <WriteKvk />, data: { stellarSeason, kvk } })
    }

    useEffect(() => {
        if (characters.$state.current) {
            koalition.get(`/servers/${characters.$state.current.server._id}/stellarSeasons`).then((response) => {
                const stellarSeasons = response.data
                stellarSeasons.sort((s1, s2) => s2.name - s1.name)
                data.save(`stellarSeasons`, stellarSeasons)
            }).catch((error) => {
                toaster.error(error)
                console.error(error)
            })
        }
    }, [characters.$state])

    return (
        <div className="stellar-seasons">
            <header className="container-fluid mb-5">
                <div className="row justify-content-end">
                    <div className="col-auto">
                        <button className="primary large" onClick={onNewStellarSeasonClick}>New Stellar Season</button>
                    </div>
                </div>
            </header>

            <main className="container-fluid">
                <ul className="row">
                    {data.$state.stellarSeasons?.map((season) => (
                        <li className="col-12 mb-3" key={season._id}>
                            <div className={`card season base ${season.current ? 'current' : ''} h-100`}>
                                <header className="row align-items-center" onClick={() => onStellarSeasonClick(season._id)}>
                                    <h3 className="col-auto">Season {season.name}</h3>
                                    {season.current && <span className="col-auto indicator">Current</span>}
                                    <div className="col-auto ml-auto">
                                        <button className={`${isMarked(season._id) ? 'danger outline marked' : 'primary'} small icon`} onClick={(event) => onStellarSeasonDeleteClick(event, season._id)}>
                                            <img src="/images/icons/trash.svg" />
                                        </button>
                                    </div>
                                </header>

                                <section className="kvks">
                                    <hr className="my-3" />

                                    <header className="row align-items-center">
                                        <h4 className="col-auto">Kvks</h4>

                                        <div className="col-auto">
                                            <button className="primary small" onClick={() => onNewKvkClick(season)}>New</button>
                                        </div>
                                    </header>

                                    {!!season.kvks.length && (
                                        <main className="mt-4">
                                            <ul className="row">
                                                {season.kvks.map((kvk) => (
                                                    <li className="col-md" key={kvk._id}>
                                                        <div className="card base semi-dark flex-center" onClick={() => onKvkEditClick(season, kvk)}>
                                                            {kvk.type.toUpperCase()}
                                                        </div>
                                                    </li>
                                                ))}
                                            </ul>
                                        </main>
                                    )}
                                </section>
                            </div>
                        </li>
                    ))}
                </ul>
            </main>
        </div>
    )
}

export default StellarSeasons